import { lazy, Suspense } from 'react';
//community
import communityRouter from '../community/router/communityAdminRouter';
const Loading = <div>Loading....</div>;
const MemberList = lazy(() => import('../pages/Admin/MemberListPage'));
const EducationList = lazy(() => import('../pages/Admin/EducationListPage'));
const WriteCurriculum = lazy(() => import('../pages/Admin/WriteCurriculumPage')); // 함수 import

const adminRouter = () => {
  return [
    {
      path: '',
      element: <Suspense fallback={Loading}></Suspense>,
    },
    {
      path: 'member',
      element: (
        <Suspense fallback={Loading}>
          <MemberList />
        </Suspense>
      ),
    },
    {
      path: 'education',
      element: (
        <Suspense fallback={Loading}>
          <EducationList />
        </Suspense>
      ),
    },
    {
      path: 'writeCurriculum',
      element: (
        <Suspense fallback={Loading}>
          <WriteCurriculum />
        </Suspense>
      ),
    },

    {
      path: 'community',
      children: communityRouter(),
    },
  ];
};

export default adminRouter;
